<template>
  <div :class="getCss('copyright-container')" :style="copyrightContainerStyle">
    <p :class="getCss('base-text')">
      <span>
        {{ prependText }}
        <a
          href="javascript:void(0);"
          :style="linkStyle"
          :class="getCss('base-text-link')"
          @click="cancelCopyright()"
        >{{ targetText }}</a>
        {{ appendText }}
      </span>
    </p>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';

export default {
  name: 'CTgclubCopyrightCancel',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'copyright-cancel-',
    };
  },
  computed: {
    prependText() {
      const text = this.configurationData.text.replace(/(\{\{.*\}\})/g, '|').split('|');
      if (text.length) {
        return text[0];
      }
      return '';
    },
    appendText() {
      const text = this.configurationData.text.replace(/(\{\{.*\}\})/g, '|').split('|');
      if (text.length) {
        return text[1];
      }
      return '';
    },
    targetText() {
      const text = this.configurationData.text.match(/(\{\{.*\}\})/g);
      if (text.length) {
        return text[0].replace('{{', '').replace('}}', '');
      }
      return '';
    },
    linkStyle() {
      const { linkColor =  '#e6d3a4' } = this.styles.copyRightAreaStyle || {};
      return {
        color: linkColor,
      };
    },
    copyrightContainerStyle() {
      const { color = '#e6d3a4', backgroundColor = '#000000', fontFamily,
        opacity = '0.4', fontSize = '0.2rem' } = this.styles.copyRightAreaStyle || {};
      return {
        fontFamily,
        fontSize,
        color,
        background: `rgba(${parseInt(`0x${backgroundColor.slice(1, 3)}`, 10)},${parseInt(`0x${backgroundColor.slice(3, 5)}`, 10)},${parseInt(`0x${backgroundColor.slice(5, 7)}`, 10)},${opacity}`,
        ...this.styles.base,
      };
    },
    isIOS() {
      return this.$platform.isIos;
    },
  },
  mounted() {
    console.log('configurationData= copyright-cancel', this.configurationData);
    this.initialize();
  },
  methods: {
    initialize() {
    },
    async cancelCopyright() {
      const { gid = 0 } = this.configurationData;
      if (gid > 0) {
        if (this?.$ast?.isAPP()) {
          window.event && window.event.preventDefault();
          if (this.$astTgclubPlugin?.currentAstName() === 'SPARK') {
            window?.SX_WEB?.jsBridge.ui.openUrl({
              url: `tgclub://native_gamezone?moduleName=gamezone&gid=${gid}`,
              target: 2,
            });
          } else {
            window.location.href = `tgclub://native_gamezone?moduleName=gamezone&gid=${gid}`;
          }
        } else {
          this?.$ast?.gotoAPP();
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
